import axios from 'axios';
import { authManager } from 'services/auth';
import { IAxiosError, IAxiosRequestConfig } from './types';

// ==========================================:
export const onError = async (error: IAxiosError) => {
	const requestConfig = error.config as IAxiosRequestConfig | undefined;
	const status = error.response?.status;

	if (status !== 401 || !requestConfig || requestConfig._retry) return Promise.reject(error);

	requestConfig._retry = true;

	const accessToken = await authManager.recoverFromUnauthorized(requestConfig._accessToken ?? null);
	if (!accessToken) return Promise.reject(error);

	const previous = String(requestConfig.headers?.Authorization ?? '');
	requestConfig.headers = {
		...requestConfig.headers,
		Authorization: previous.startsWith('Bearer ') ? `Bearer ${accessToken}` : accessToken,
	};
	requestConfig._accessToken = accessToken;

	return axios(requestConfig);
};
